var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ElementRef, EventEmitter, OnDestroy, OnInit, QueryList, ViewChildren, } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomEventCommand } from '../../../commands/hub/custom.event.command';
import { VisitorCalendarActionCommand, VisitorStyleCommand, } from '../../../commands/pagination.query.command';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { BaseComponent } from '../../../common/components/base.component';
import { FacebookLoginButtonComponent } from '../../../common/components/facebook.login.button/facebook.login.button.component';
import { PlaceCategory } from '../../../common/constants/constant';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { bindFunctionsToThis } from '../../../common/extensions';
import { ModalService } from '../../../common/services/modal.service';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { AllFrontendSettingsStore, VisitorCalendarStore, VisitorStyleStore, } from '../../../stores/visitor.calendar.store';
import { VisitorComponent } from '../visitor.component';
import { DateFieldComponent } from '../../../common/components/date.time.field/date.field.component';
import { EditorChoiceStore } from '../../../stores/hub.calendar.store';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { NestedMenusComponent } from '../../../common/components/nested.menu/nested.menu.component';
import { EventFilterComponent } from '../event.filter/event.filter.component';
import { CustomDefaultPlaceCategoryAccordionComponent } from '../../hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
import { CustomPlaceBtnComponent } from '../custom.place.btn/custom.place.btn.component';
import { PlaceService } from '../../../services/place.service';
import { Location } from '@angular/common';
var VisitorTopBarComponent = /** @class */ (function (_super) {
    __extends(VisitorTopBarComponent, _super);
    function VisitorTopBarComponent(router, activatedRoute, visitorCalendarStore, formBuilder, parent, editorChoiceStore, visitorApiService, visitorStyleStore, allFrontendSettingsStore, location, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.formBuilder = formBuilder;
        _this.parent = parent;
        _this.editorChoiceStore = editorChoiceStore;
        _this.visitorApiService = visitorApiService;
        _this.visitorStyleStore = visitorStyleStore;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.location = location;
        _this.modalService = modalService;
        _this.from = null;
        _this.to = null;
        _this.command = new VisitorCalendarActionCommand();
        _this.simpleMenu = false;
        _this.searchParam = {
            searchTimeout: null,
            debounceTime: 500,
            isSearching: false,
        };
        _this.onClose = new EventEmitter();
        _this.selectedCustomEvent = new CustomEventCommand();
        _this.selectedCustomPlace = null;
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.toggleAndSource = new HubVisitorToggleDataSource();
        _this.loadingToggles = true;
        _this.editorChoiceText = '';
        _this.selectedEvents = null;
        _this.isEditorChoice = null;
        _this.customDefaultPlaceCategory = null;
        bindFunctionsToThis(_this);
        return _this;
    }
    VisitorTopBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, category = _a.category, menuType = _a.menuType, customPlaceBtnId = _a.customPlaceBtnId;
        this.hubName = hubName;
        this.category = category || 'All';
        this.menuType = menuType || null;
        this.simpleMenu = menuType === 'simple';
        this.categoryId = customPlaceBtnId || null;
        this.command.queryCommand.category = category;
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.visitorCalendarStore.actionCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            _this.command = command;
            console.log('command in topbar', _this.command);
            _this.setQueryCommand();
            _this.setSelectedDefaultCategoryFilterBackFromMapView();
            // custom place btn selected
            if (_this.command.queryCommand.customPlaceBtnText) {
                _this.customPlaceBtn &&
                    _this.customPlaceBtn.setFilter(_this.command.queryCommand.customPlaceBtnText, _this.command.queryCommand.choice);
            }
            else {
                _this.customPlaceBtn && _this.customPlaceBtn.clearFilter();
            }
        });
        this.searchFormGroup = this.formBuilder.group({
            searchText: [null],
        });
        this.dateFormGroup = this.formBuilder.group({
            from: [null, [Validators.required]],
            to: [null, [Validators.required]],
        });
        this.loadingToggles = true;
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.customSettings) {
                _this.customEvents = command.customSettings.customEvents || null;
                _this.customPlaces = command.customSettings.customPlaces || null;
                _this.isHideEditorChoice = command.customSettings.isHideEditorChoice || false;
                //this.visitorPromotionImage = command.customSettings.visitorPromotionImage || null;
                _this.setCustomDefaultPlaceCategory(command.customSettings.customDefaultPlaceCategory);
            }
            if (command.toggle) {
                _this.featuresToggle = command.toggle;
                _this.toggleAndSource.toggle = _this.featuresToggle;
                _this.toggleAndSource.dataSource = command.dataSource;
                _this.loadingToggles = false;
            }
        });
        this.setWidth();
        this.editorChoiceTextHandler();
    };
    VisitorTopBarComponent.prototype.setQueryCommand = function () {
        var _this = this;
        !!this.activatedRoute.firstChild &&
            this.activatedRoute.firstChild.url.subscribe(function (x) {
                // this.command.isEventCalendar = (x[0].path === routeConfigs.visitor.eventCalendar.path || routeConfigs.visitor.eventDetailsModal.path.indexOf(x[0].path) >= 0);
                if (x[0].path === routeConfigs.visitor.eventCalendar.path ||
                    x[0].path === routeConfigs.visitor.editorChoice.path ||
                    routeConfigs.visitor.createEvent.path.indexOf(x[0].path) >= 0 ||
                    routeConfigs.visitor.customEvent.path.indexOf(x[0].path) >= 0 ||
                    routeConfigs.visitor.eventDetailsModal.path.indexOf(x[0].path) >= 0) {
                    _this.command.isEventCalendar = true;
                }
                else {
                    _this.command.isEventCalendar = false;
                }
                if (x[0].path === routeConfigs.visitor.editorChoice.path ||
                    x[0].path === routeConfigs.visitor.placeEditorChoice.path) {
                    _this.command.queryCommand.choice = true;
                }
                // else {
                //     this.command.queryCommand.choice = false;
                // }
            });
    };
    VisitorTopBarComponent.prototype.ngAfterViewInit = function () {
        window.addEventListener('click', this.closeAccordion);
    };
    VisitorTopBarComponent.prototype.ngOnDestroy = function () {
        window.removeEventListener('click', this.closeAccordion);
    };
    VisitorTopBarComponent.prototype.editorChoiceTextHandler = function () {
        var _this = this;
        this.editorChoiceStore.infoCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (editorChoice) {
            if (!!_this.command.isEventCalendar) {
                _this.editorChoiceText = editorChoice.editorChoiceForEvent;
            }
            else {
                _this.editorChoiceText = editorChoice.editorChoiceForPlace;
            }
        });
    };
    VisitorTopBarComponent.prototype.setSelectedDefaultCategoryFilterBackFromMapView = function () {
        var _this = this;
        // get the selected category back from map view
        if (this.command.queryCommand.category) {
            if (this.menuType !== 'custom') {
                this.category = this.command.queryCommand.category;
                this.setCustomDefaultPlaceFilter(this.category);
            }
            else {
                setTimeout(function () {
                    try {
                        var str = localStorage.getItem(localStorageKeys.selectedPlaceCategory);
                        var data = str ? JSON.parse(str) : { title: _this.command.queryCommand.category };
                        if (data) {
                            _this.setCustomDefaultPlaceFilter(data.title);
                        }
                    }
                    catch (error) {
                        console.log('Not parse selectedPlaceCategory', error.message);
                    }
                }, 1600);
            }
        }
    };
    VisitorTopBarComponent.prototype.setCustomDefaultPlaceFilter = function (title) {
        title = title || '';
        title = title.toLowerCase() === 'all' ? '' : title;
        this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.setFilter(title);
    };
    /**
     * if visit a custom default place category url, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
     * */
    VisitorTopBarComponent.prototype.setCustomDefaultPlaceCategory = function (customDefaultPlaceCategory) {
        if (this.menuType === 'custom') {
            // this.category is the custom default place category id, e.g., 62a46ea3e6ad6016f05245ff
            var data = PlaceService.getCustomDefaultCategoryFromURL(this.category, customDefaultPlaceCategory);
            if (data) {
                this.categoryId = this.category;
                this.category = data.category.title;
                // this.customDefaultPlaceCategory = data.customDefaultPlaceCategory;
                this.customDefaultPlaceCategory = customDefaultPlaceCategory;
                this.command.queryCommand.categoryList = data.categoryList;
                var categoryString = JSON.stringify(data.category);
                this.initialCustomDefaultPlaceCategory = {
                    category: data.category,
                    categoryString: categoryString,
                    categoryList: data.categoryList,
                };
                // for map view
                localStorage.setItem(localStorageKeys.selectedPlaceCategory, categoryString);
            }
        }
        else {
            this.customDefaultPlaceCategory = customDefaultPlaceCategory;
        }
        this.visitorCalendarStore.actionCommand.next(this.command);
    };
    Object.defineProperty(VisitorTopBarComponent.prototype, "isShowThingsToDo", {
        get: function () {
            return (!this.loadingToggles &&
                (this.featuresToggle.placeCategory.activity ||
                    this.featuresToggle.placeCategory.art ||
                    this.featuresToggle.placeCategory.outdoor ||
                    this.featuresToggle.placeCategory.entertainment));
        },
        enumerable: true,
        configurable: true
    });
    VisitorTopBarComponent.prototype.closeAccordion = function (target) {
        if (target &&
            target.srcElement &&
            (target.srcElement.className.indexOf('md2-datepicker') >= 0 ||
                target.srcElement.className.indexOf('md2-calendar') >= 0 ||
                target.srcElement.className.indexOf('ng-tns') >= 0 ||
                target.srcElement.className.indexOf('value') >= 0)) {
            return;
        }
        this.eventDateAccordion && this.eventDateAccordion.close();
        this.customEventAccordion && this.customEventAccordion.close();
        this.manualAccordion && this.manualAccordion.close();
        this.customPlaceAccordion && this.customPlaceAccordion.close();
        this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.close();
        this.customPlaceBtn && this.customPlaceBtn.close();
    };
    Object.defineProperty(VisitorTopBarComponent.prototype, "isEventEnabled", {
        get: function () {
            return this.featuresToggle.manualEvents || this.featuresToggle.eventByGeolocation;
        },
        enumerable: true,
        configurable: true
    });
    VisitorTopBarComponent.prototype.viewChange = function () {
        var command = new VisitorCalendarActionCommand();
        this.command.isMapView = !this.command.isMapView;
        command = this.command;
        var path = { path: '' };
        if (command.isMapView) {
            if (this.command.isEventCalendar) {
                path = routeConfigs.visitor.eventMap;
            }
            else {
                path = routeConfigs.visitor.placeMap;
            }
        }
        else {
            if (this.command.isEventCalendar) {
                path = routeConfigs.visitor.eventCalendar;
            }
            else {
                path = routeConfigs.visitor.placeCalendar;
            }
        }
        if (this.command.isEventCalendar) {
            this.router.navigateByUrl(getRouteUrl(path, {
                hubName: this.hubName,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        else {
            // custom-places is the custom place button place category
            console.log('location--', this.location.path());
            if (this.menuType === 'custom-places' || this.location.path().includes('/custom-places/')) {
                console.log('path', path);
                console.log('this.categoryId', this.categoryId);
                this.router.navigateByUrl(getRouteUrl(path, {
                    hubName: this.hubName,
                    category: 'custom-places',
                    menuType: this.categoryId,
                }), { skipLocationChange: this.noChangeUrlWhenRedirect });
            }
            else {
                // menuType = custom is the custom default place category
                var cate = this.customDefaultPlaceCategory.useDefault
                    ? PlaceCategory.getPlaceCategoryKey(this.category)
                    : this.menuType === 'custom'
                        ? this.categoryId
                        : 'All';
                this.router.navigateByUrl(getRouteUrl(path, {
                    hubName: this.hubName,
                    category: cate,
                    menuType: this.menuType || (this.simpleMenu ? 'simple' : 'normal'),
                }), { skipLocationChange: this.noChangeUrlWhenRedirect });
            }
        }
        this.visitorCalendarStore.actionCommand.next(command);
    };
    VisitorTopBarComponent.prototype.close = function () {
        this.onClose.emit();
    };
    VisitorTopBarComponent.prototype.gotoEventCalendar = function () {
        this.searchText = null;
        this.category = 'All';
        var path = this.command.isMapView ? routeConfigs.visitor.eventMap : routeConfigs.visitor.eventCalendar;
        this.command.isEventCalendar = true;
        this.command.queryCommand.category = 'All';
        this.command.queryCommand.choice = null;
        this.command.queryCommand.isCustom = null;
        this.command.queryCommand.feedId = null;
        this.command.queryCommand.from = null;
        this.command.queryCommand.to = null;
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.visitorStyleStore.styleCommand.next(new VisitorStyleCommand());
        this.router.navigateByUrl(getRouteUrl(path, {
            hubName: this.hubName,
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
    };
    VisitorTopBarComponent.prototype.gotoPlaceCalendar = function () {
        this.searchText = null;
        this.category = 'All';
        var path = this.command.isMapView ? routeConfigs.visitor.placeMap : routeConfigs.visitor.placeCalendar;
        this.command.isEventCalendar = false;
        this.command.queryCommand.category = 'All';
        this.command.queryCommand.from = null;
        this.command.queryCommand.to = null;
        this.command.queryCommand.choice = null;
        this.command.queryCommand.isCustom = null;
        this.command.queryCommand.feedId = null;
        this.visitorCalendarStore.actionCommand.next(this.command);
        var styleCommand = new VisitorStyleCommand();
        styleCommand.menuStyle.isSideBar = this.parent.allFrontendSettings.customSettings.menuStyle.isSideBar;
        // styleCommand.menuStyle.menuBarMode = this.parent.menuBarMode;
        this.visitorStyleStore.styleCommand.next(styleCommand);
        this.router.navigateByUrl(getRouteUrl(path, {
            hubName: this.hubName,
            category: this.category,
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
    };
    VisitorTopBarComponent.prototype.gotoTripPlanner = function () {
        var path = routeConfigs.tripPlanner.trip; //routeConfigs.visitor.trip;
        this.router.navigateByUrl(getRouteUrl(path, {
            hubName: this.hubName,
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
    };
    VisitorTopBarComponent.prototype.search = function ($event) {
        var _this = this;
        if ($event && $event.key === 'Tab') {
            return;
        }
        /**
         * search in all events, or with current filters?
         * */
        var isKeepFilter = false;
        if (!isKeepFilter) {
            this.customPlaceAccordion && this.customPlaceAccordion.clearFilter(null, false);
            this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
            this.selectedEvents = null;
            this.isEditorChoice = null;
            this.from = null;
            this.to = null;
            this.category = 'all';
            this.eventFilter && this.eventFilter.clearFilter();
        }
        var command = this.command;
        command.queryCommand.search = this.searchText || null;
        command.queryCommand.from = this.from;
        command.queryCommand.to = this.to;
        command.queryCommand.category = this.category;
        command.queryCommand.choice = this.isEditorChoice;
        command.queryCommand.selectedEvents = this.selectedEvents;
        command.queryCommand.customEventBtnText = null;
        command.queryCommand.dateFilterText = null;
        command.queryCommand.feedId = null;
        command.queryCommand.isCustom = null;
        if (!this.command.isEventCalendar) {
            command.queryCommand.from = null;
            command.queryCommand.to = null;
        }
        command.isEventCalendar = this.command.isEventCalendar;
        //this.visitorCalendarStore.actionCommand.next(command);
        if (this.searchParam.searchTimeout) {
            clearTimeout(this.searchParam.searchTimeout);
            this.searchParam.searchTimeout = setTimeout(function () {
                _this.searchParam.isSearching = true;
                setTimeout(function () {
                    _this.searchParam.isSearching = false;
                }, 3000);
                _this.visitorCalendarStore.actionCommand.next(command);
            }, this.searchParam.debounceTime);
            return;
        }
        this.searchParam.searchTimeout = setTimeout(function () {
            _this.searchParam.isSearching = true;
            setTimeout(function () {
                _this.searchParam.isSearching = false;
            }, 2000);
            _this.visitorCalendarStore.actionCommand.next(command);
        }, this.searchParam.debounceTime);
    };
    VisitorTopBarComponent.prototype.filterPlace = function (category) {
        this.searchText = null;
        //category = PlaceCategory.getPlaceCategoryValue(category);
        var command = new VisitorCalendarActionCommand();
        command.isEventCalendar = false;
        command.queryCommand.choice = null;
        command.queryCommand.search = null;
        this.selectedCustomPlace = null;
        var path = this.command.isMapView ? routeConfigs.visitor.placeMap : routeConfigs.visitor.placeCalendar;
        if (category === 'selected') {
            command.queryCommand.isCustom = true;
            command.queryCommand.category = null;
            this.category = category;
            this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
            this.customPlaceBtn && this.customPlaceBtn.clearFilter();
            this.router.navigateByUrl(getRouteUrl(path, {
                hubName: this.hubName,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        else {
            // custom default category from URL, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
            if (this.menuType === 'custom') {
                // all selected, load all categroyList
                command.queryCommand.categoryList = this.initialCustomDefaultPlaceCategory.categoryList;
                // for map view
                localStorage.setItem(localStorageKeys.selectedPlaceCategory, this.initialCustomDefaultPlaceCategory.categoryString);
            }
            else {
                this.category = category;
                command.queryCommand.category = category || null;
                this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
                this.customPlaceBtn && this.customPlaceBtn.clearFilter();
            }
            this.router.navigateByUrl(getRouteUrl(path, {
                hubName: this.hubName,
                category: this.menuType === 'custom' ? this.categoryId : PlaceCategory.getPlaceCategoryKey(this.category),
                menuType: this.menuType,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        this.visitorCalendarStore.actionCommand.next(command);
    };
    VisitorTopBarComponent.prototype.selectCustomDefaultPlaceCategory = function ($event) {
        console.log({ $event: $event });
        this.command.isEventCalendar = false;
        this.command.queryCommand.feedId = null;
        this.command.queryCommand.category = $event ? $event.title : 'all';
        // this.command.queryCommand.categoryName = $event.title;
        this.command.queryCommand.categoryList = $event ? $event.categoryList : null;
        this.command.queryCommand.type = undefined;
        this.command.queryCommand.search = '';
        this.command.queryCommand.isCustom = undefined;
        // for map view
        localStorage.setItem(localStorageKeys.selectedPlaceCategory, JSON.stringify(this.command.queryCommand.categoryList));
        this.visitorCalendarStore.actionCommand.next(this.command);
        // in order for calendar to load when currently showing submit place view
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeCalendar, {
            hubName: this.hubName,
            // category: this.menuType === 'custom' ? $event._id : 'All',
            category: $event._id,
            menuType: 'custom',
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        $event && this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.setFilter($event._id);
        !$event && this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
        this.customPlaceAccordion && this.customPlaceAccordion.clearFilter(null, false);
        this.customPlaceBtn && this.customPlaceBtn.clearFilter();
    };
    VisitorTopBarComponent.prototype.customPlaceBtnSelected = function (command) {
        console.log('customPlaceBtnSelected', command);
        this.menuType = 'custom-places';
        this.categoryId = command._id;
        this.category = 'All';
        this.customDefaultPlaceAccordion && this.customDefaultPlaceAccordion.clearFilter();
    };
    VisitorTopBarComponent.prototype.addEventsManually = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.createEvent, {
            hubName: this.hubName,
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
    };
    VisitorTopBarComponent.prototype.addPlacesManually = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.createPlace, {
            hubName: this.hubName,
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
    };
    VisitorTopBarComponent.prototype.setWidth = function () {
        var _this = this;
        setTimeout(function () {
            var topBarWidth = _this.topBar.nativeElement.getBoundingClientRect().width;
            if (topBarWidth < 1470) {
                var headers = _this.topBar.nativeElement.getElementsByClassName('ig-according-header');
                var spans = _this.topBar.nativeElement.getElementsByClassName('mat-button-wrapper');
                var btns = _this.topBar.nativeElement.getElementsByClassName('btn');
                var icons = _this.topBar.nativeElement.querySelectorAll('.btn .mat-icon');
                for (var i = 0; i < spans.length; i++) {
                    spans[i].style.fontSize = '12px';
                }
                for (var i = 0; i < headers.length; i++) {
                    headers[i].style.fontSize = '12px';
                    headers[i].style.paddingLeft = '8px';
                }
                for (var i = 0; i < btns.length; i++) {
                    btns[i].style.paddingLeft = '8px';
                }
                for (var i = 0; i < icons.length; i++) {
                    icons[i].style.right = '4px';
                }
            }
        });
    };
    VisitorTopBarComponent.prototype.onLoad = function () {
        console.log('is window:load');
        var start = window.performance.timing.domLoading;
        var end = window.performance.timing.domComplete;
        console.log('dom', end - start);
        var paint = window.performance.getEntriesByType('paint');
        var fp = paint.find(function (e) { return e.name === 'first-paint'; }).startTime;
        var fcp = paint.find(function (e) { return e.name === 'first-contentful-paint'; }).startTime;
        console.log("fp: " + fp + ", fcp: " + fcp);
        // let observer = new PerformanceObserver((list, obs) => {
        //     list.getEntries().forEach(x => {
        //         console.log(x);
        //     })
        // });
        // observer.observe({entryTypes: ['paint', 'resource', 'mark']});
        //
        // window.performance.mark('own');
    };
    return VisitorTopBarComponent;
}(BaseComponent));
export { VisitorTopBarComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/top.bar/visitor.top.bar.component.ts.pre-build-optimizer.js